export const infoWindowOpenAction = (data) => {
    return {
        type: 'HANDLE_INFO_WINDOW_OPEN',
        payload: data
    }
}

export const infoWindowCloseAction = () => {
    return {
        type: 'HANDLE_INFO_WINDOW_CLOSE',
    }
}